const menu = [
  {
    id: 'biriyanis',
    title: 'Biriyanis',
    eyebrow: 'Slow-cooked, layered, fragrant',
    note: 'Each available with Fish, Chicken, Beef, or Mutton.',
    items: [
      {
        name: 'Malabar Biriyani',
        description: 'Short-grain Khyma rice layered with spiced meat, fried onions, raisins, and ghee. The northern Kerala classic.',
        variants: ['Fish', 'Chicken', 'Beef', 'Mutton']
      },
      {
        name: 'Thalassery Biriyani',
        description: "Fragrant, lighter, with a coastal heat. Thalassery's signature dum-cooked biriyani.",
        variants: ['Fish', 'Chicken', 'Beef', 'Mutton']
      }
    ]
  },
  {
    id: 'curries-and-roasts',
    title: 'Curries & Roasts',
    eyebrow: 'House spice, slow time',
    items: [
      {
        name: 'Fish Curry (Red Kudampuli)',
        description: 'Tangy red gravy with kudampuli (Malabar tamarind), coconut, and fenugreek. Best with rice.'
      },
      {
        name: 'Fish Curry (Meenachilar Style)',
        description: 'Coconut-cream gravy with green chili and curry leaf, the central Kerala river-bank style.'
      },
      {
        name: 'Chicken Roast',
        description: 'Slow-roasted with a thick masala of shallots, black pepper, and roasted coconut.'
      },
      {
        name: 'Beef Curry',
        description: 'House-blend Kerala spices, slow-simmered to fall-apart tender.'
      },
      {
        name: 'Beef Roast',
        description: 'Dark, dry-braised beef tossed with curry leaf, coconut slivers, and pepper.'
      },
      {
        name: 'Beef Fry (Ularthiyathu)',
        description: 'The Kottayam-style stir-fry: caramelized, peppery, with crisped curry leaves.'
      },
      {
        name: 'Mutton Curry',
        description: 'Bone-in mutton in a deep, ghee-finished gravy with whole spices.'
      }
    ]
  },
  {
    id: 'appetizers',
    title: 'Appetizers',
    eyebrow: 'Crackling, peppery, fried fresh',
    items: [
      {
        name: 'Chicken 65',
        description: 'Crispy bites in a fiery red marinade. The South Indian bar classic.'
      },
      {
        name: 'Chili Chicken',
        description: 'Indo-Chinese, soy-glazed with green chili and onion.'
      },
      {
        name: 'Chicken Mullapanthal',
        description: 'Toddy-shop style, fried with shallots and curry leaf.'
      },
      {
        name: 'Chicken Kondattam',
        description: 'Sun-spice rubbed and pan-fried until crackling.'
      },
      {
        name: 'Chicken Manchurian',
        description: 'Tossed in a tangy, garlicky Indo-Chinese sauce.'
      },
      {
        name: 'Chicken Pepper Fry',
        description: 'Black pepper, ginger, garlic, and curry leaf. Heat-forward.'
      },
      {
        name: 'Goat Pepper Fry',
        description: 'Tender goat tossed in coarse black pepper masala.'
      }
    ]
  },
  {
    id: 'tea-snacks',
    title: 'Tea Snacks',
    eyebrow: 'For the chai hour',
    items: [
      {
        name: 'Pazhampori (Banana Fry)',
        description: 'Ripe plantain in a crisp golden batter.'
      },
      {
        name: 'Chicken Samosa',
        description: 'Spiced chicken in flaky pastry, fried to order.'
      },
      {
        name: 'Veg Samosa',
        description: 'Potato, peas, and Kerala spices in a crisp triangle.'
      },
      {
        name: 'Uzhunhu Vada',
        description: 'Lentil donuts with a crackling crust and pillowy inside.'
      },
      {
        name: 'Parippu Vada',
        description: "Spiced split-pea fritters. Kerala's tea-shop staple."
      },
      {
        name: 'Onion Vada',
        description: 'Sliced onion, ginger, and curry leaf in a chickpea-flour fry.'
      },
      {
        name: 'Egg Puff',
        description: 'Hard-boiled egg wrapped in flaky pastry.'
      },
      {
        name: 'Chicken Puff',
        description: 'Spiced chicken in buttery, golden puff pastry.'
      },
      {
        name: 'Sukhiyan',
        description: 'Sweetened mung bean filling in a crisp shell. An old-school Kerala tea-shop favorite.'
      },
      {
        name: 'Kilikoodu',
        description: "Bird's-nest of crisp vermicelli with a savory-sweet center."
      }
    ]
  }
];

export default menu;
